import { render, staticRenderFns } from "./EvaluacionIdentificacionPagination.vue?vue&type=template&id=67da8c5b&"
import script from "./EvaluacionIdentificacionPagination.vue?vue&type=script&lang=js&"
export * from "./EvaluacionIdentificacionPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports